// ----------------------------------------------------------------------------
// Snippet: Country Modal
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
// Scripts
import 'snippets/_containers/modal/modal';

// Styles
import './_country-modal.scss';

/**
 * Country Modal Snippet Script
 * ------------------------------------------------------------------------------
 * A file that manage the country popup switcher when the user first comes to the website.
 * There will be no popup for returning users.
 */

var inIframe = function() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

const openCountryModal = (geoCountryCode) => {

    let country_modal = document.querySelector('#country-modal');
    country_modal.classList.add(`modal--${geoCountryCode}`);
    country_modal.classList.add('modal--open');
    document.body.setAttribute('data-country', geoCountryCode);
    let country_modal_content = country_modal.querySelector(`.country-modal__content.country--${geoCountryCode}`);

    const closeButton = country_modal.querySelector('.modal__close-button');

    // Lock document Body
    document.body.classList.add('noscroll');
    document.body.classList.add('lockscroll');
    document.body.classList.add('country-modal-open');

    // Enable focus when opening modal
    country_modal.querySelectorAll('[tabindex="-1"]').forEach(modalContent => {
        modalContent.setAttribute('tabindex', '0');
    });

    closeButton.focus();


    // add all the elements inside modal which you want to make focusable
    if( country_modal_content !== null ) {
        const focusableElements     = country_modal_content.querySelectorAll('[tabindex]:not([tabindex="-1"]), [href], button, input, iframe');
        const firstFocusableElement = focusableElements[0]; // get first element to be focused inside modal
        const lastFocusableElement  = focusableElements[focusableElements.length - 1]; // get last element to be focused inside modal
    
        document.addEventListener('keydown', function(e) {
            const isTabPressed = e.key === 'Tab';
    
            if (!isTabPressed) {
                return;
            }
    
            if (e.shiftKey) { // if shift key pressed for shift + tab combination
                if (document.activeElement === firstFocusableElement) {
                    e.preventDefault();
                    lastFocusableElement.focus(); // add focus for the last focusable element
                }
            } else { // if tab key is pressed
                if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                    e.preventDefault();
                    firstFocusableElement.focus(); // add focus for the first focusable element
                }
            }
        });
    }

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') { // Esc key
            if (document.body.classList.contains('country-modal-open')) {
                const linkCountry = document.body.getAttribute('data-country');
                localStorage.setItem('userCountry', linkCountry);
            }
        }
    });

};

// Country Switch Popup
var doLocale = function() {

    var countryMap = {
        'ridefox-ca.myshopify.com': 'CA',
        'ca.ridefox.com'          : 'CA',
        'shop.ridefox.com'        : 'CA',
        'ridefoxeu.myshopify.com' : 'DE',
        'eu.ridefox.com'          : 'DE',
        'shop.foxracingshox.de'   : 'DE',
        'ridefox-us.myshopify.com': 'US',
        'ridefox.com'             : 'US',
        'au.ridefox.com'          : 'AU',
        'ridefox-australia.myshopify.com': 'AU',
        'ridefox-us-staging.myshopify.com': 'US'
    };

    var hostCountry = countryMap[location.hostname];

    // If URL does not match any of the countries in the map, do nothing
    if (hostCountry === undefined) {
        return;
    }

    // Don't show the modal if If we are inside the customizer.
    if (inIframe()) { return; }

    /**
     * Return Visitor!
     */
    if (localStorage.getItem('userCountry') !== null) {

        // Do nothing
    }

    /**
    * Show the modal if GeoIP2 fails to load or is blocked for security
    */
    else if (typeof geoip2 === 'undefined') {

        // Do nothing
    }

    /**
     * Newbie user!
     */
    else {
        //GeoIP fetched successfully
        var geoSuccess = function(location) {
            var geoCountryCode = location.country.iso_code;
            const hostCountries = Object.values(countryMap);

            if (!hostCountries.includes(geoCountryCode)) {
                return;
            }
            // assign country to localStorage.
            localStorage.setItem('geoCountry', geoCountryCode);

            // CHECK! Does geo country match host country?
            if ( hostCountry.includes(geoCountryCode) !== true ) {
                openCountryModal(geoCountryCode);
            }
        };
        // GeoIP Failed, show popup always
        var geoError = function(err) {
            console.error(err);
        };

        // Get location from geoip database
        geoip2.country(geoSuccess, geoError);
    }


    document.querySelectorAll('#country-modal .country-popup__item, #country-modal .country-popup__button, #country-modal .modal__overlay, #country-modal .modal__close-button').forEach(button => {
        button.addEventListener('click', function(e){
            e.preventDefault();

            const linkCountry = button.getAttribute('data-country');
            localStorage.setItem('userCountry', linkCountry);


            // Unlock document Body
            document.body.classList.remove('noscroll');
            document.body.classList.remove('lockscroll');
            document.body.classList.remove('country-modal-open');

            if ( hostCountry.includes(linkCountry) === true) {
                document.querySelector('#country-modal').classList.remove('modal--open');
            } else {
                window.location = button.getAttribute('href');
            }
        });
    });
};
doLocale();
